import React from 'react';
import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import Form from 'react-bootstrap/Form';
import { renderField, renderSelect } from '../../../lib/helper/form';
import { getFiltersFromSession } from '../../../lib/routing/filters';
import { insuranceDetailUpdateListClearFilters, insuranceDetailUpdateListSetFilters } from '../../../lib/redux/actions/insuranceDetails';

//const validate = (values) => {
//  const errors = {};
////  if (values['outstandingBalance(gte)'] && values['outstandingBalance(lte)'] && values['outstandingBalance(lte)'] < values['outstandingBalance(gte)']) {
////    errors['outstandingBalance(lte)'] = 'Less than must be smaller than greater than';
////    errors['outstandingBalance(gte)'] = 'Less than must be smaller than greater than';
////  }
//  return errors;
//};
const mapStateToProps = (state, ownProps) => {
  const { location } = ownProps;
  let initialValuesFromSession = getFiltersFromSession(location, 'json');
  let invoiceInsuranceDetailsActioned = 0;
  if (initialValuesFromSession !== null && initialValuesFromSession['exists[actionedDate]'] !== undefined) {
    invoiceInsuranceDetailsActioned = initialValuesFromSession['exists[actionedDate]'];
  }
  let initialValues = {
    ...initialValuesFromSession,
    ...state?.insuranceDetailUpdates?.filters,
    invoiceInsuranceDetailsActioned,
  };

  return {
    initialValues,
  };
};
const mapDispatchToProps = {
  insuranceDetailUpdateListSetFilters,
  insuranceDetailUpdateListClearFilters,
};

class InsuranceDetailsUpdateTableFilterForm extends React.Component {
  onSubmit(values) {
    const { setPage, location } = this.props;

    const submitValues = { ...values };
    delete submitValues['exists[actionedDate]'];
    if (submitValues.invoiceInsuranceDetailsActioned === 'Actioned') {
      delete submitValues['invoiceInsuranceDetailsActioned'];
      submitValues['exists[actionedDate]'] = true;
    } else {
      //      console.log(0, submitValues);
      delete submitValues['invoiceInsuranceDetailsActioned'];
      submitValues['exists[actionedDate]'] = false;
    }

    if (submitValues.invoiceNo) {
      submitValues['exists[invoice]'] = true;
      submitValues['invoice.invoiceNo'] = submitValues['invoiceNo'];
      delete submitValues['invoiceNo'];
    }
    if (submitValues.invoiceBatchNo) {
      submitValues['exists[invoiceBatch]'] = true;
      submitValues['invoiceBatch.id'] = submitValues['invoiceBatchNo'];
      delete submitValues['invoiceBatchNo'];
    }

    // attempt to stop extra filter values being applied when the filter shouldn't show (if there are problems with invoice filters look here)
    const filtersToShow = this.getFiltersToShow();
    if (!filtersToShow.invoiceNo || submitValues['invoiceNo'] === undefined) {
      delete submitValues['invoiceNo'];
    }

    setPage(1);
    return this.props.insuranceDetailUpdateListSetFilters(submitValues, location);
  }

  resetFilters() {
    const { reset, insuranceDetailUpdateListClearFilters, setPage, location } = this.props;
    insuranceDetailUpdateListClearFilters(location);
    setPage(1);
    reset();
  }

  getFiltersToShow() {
    const { filterOverrides = {} } = this.props;

    return {
      ...{
        patientName: true,
        invoiceNo: true,
        invoiceBatchNo: true,
        invoiceInsuranceDetailsActioned: true,
      },
      ...filterOverrides,
    };
  }

  render() {
    const { handleSubmit, error } = this.props;

    const isActionedOptions = [
      { value: 'UnActioned', text: 'UnActioned' },
      { value: 'Actioned', text: 'Actioned' },
    ];

    const filtersToShow = this.getFiltersToShow();

    return (
      <div>
        {error && <div className="alert alert-danger">{error}</div>}
        <Form onSubmit={handleSubmit(this.onSubmit.bind(this))} className="fake-inline form-data-filters row">
          {filtersToShow.patientName && (
            <div className="col-sm-6 col-xl-2">
              <Field name="patientName" label="Patient Name" id="patientName" type="text" component={renderField} />
            </div>
          )}
          {filtersToShow.invoiceNo && (
            <div className="col-sm-6 col-xl-2">
              <Field name="invoiceNo" label="Invoice #" id="invoiceNo" type="text" component={renderField} />
            </div>
          )}
          {filtersToShow.invoiceBatchNo && (
            <div className="col-sm-6 col-xl-2">
              <Field name="invoiceBatchNo" label="Invoice Batch #" id="invoiceBatchNo" type="text" component={renderField} />
            </div>
          )}
          {filtersToShow.invoiceInsuranceDetailsActioned && (
            <div className="col-sm-6 col-xl-2">
              <Field name="invoiceInsuranceDetailsActioned" label="Actioned" options={isActionedOptions} showEmpty={false} component={renderSelect} />
            </div>
          )}

          {/*<div className="row">*/}

          <div className="col-sm-6 col-xl-2">
            <div className="filter-actions">
              <button type="submit" className="btn btn-primary btn-sm">
                Filter
              </button>
              <button type="button" className="btn btn-outline-danger btn-sm ml-2" onClick={this.resetFilters.bind(this)}>
                Reset
              </button>
            </div>
          </div>
        </Form>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  reduxForm({
    form: 'InsuranceDetailsUpdateTableFilterForm',
    enableReinitialize: true,
    //validate,
  })(InsuranceDetailsUpdateTableFilterForm),
);
